.timers{
  height:100%;
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/settings/timers/timers.scss